import styled from "styled-components";
import { Checkbox } from "@libraries/mui";

const CheckContainer = styled.div`
  display: flex;
  align-items: center;

  p {
    font-weight: bold;
  }
`;

const Description = styled.p`
  color: #666666;
  font-size: 13px;
`;

const CustomCheckbox = styled(Checkbox)`
  margin-left: 15px;
`;

export { CheckContainer, CustomCheckbox, Description };
